<template>
  <div class="menuNavigation" :class="parentUrl ? 'space' : ''">
    <template v-if="parentUrl">
      <div class="back" @click="$router.back()">
        <el-icon class="el-icon-arrow-left"></el-icon>
        <span>返回</span>
      </div>
      <span class="line"></span>
      <span class="title">{{ title }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MenuNavigation',
  data() {
    return {}
  },
  computed: {
    title() {
      return this.$route.meta ? this.$route.meta.title : ''
    },
    parentUrl() {
      if (this.$route.meta && this.$route.meta.hasBack !== false) {
        const routeUrl = this.$route.meta.backUrl || this.$route.path.substr(0, this.$route.path.lastIndexOf('/'))
        const routeQuery = this.$route.meta.hasQuery ? this.$route.query || {} : {}
        return routeUrl ? { path: routeUrl, query: routeQuery } : false
      } else {
        return false
      }
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    handleCurrentChange(value) {
      this.$emit('update:current-page', value)
      this.$emit('current-change', value)
    },
    handleSizeChange(value) {
      this.$emit('update:page-size', value)
      this.$emit('size-change', value)
    }
  }
}
</script>

<style scoped lang="scss">
.menuNavigation {
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  background: #FFFFFF;

  .back {
    height: 50px;
    line-height: 50px;
    cursor: pointer;

    i {
      margin-right: 5px;
    }
  }

  .line {
    width: 1px;
    height: 16px;
    background-color: #999999;
    margin: 0 12px;
  }
}
</style>
